import {
  SHIPMENTS_FILTER_FETCH_STARTED,
  SHIPMENTS_FILTER_FETCH_SUCCEEDED,
  SHIPMENTS_FILTER_FETCH_FAILED,
  SHIPMENTS_FILTER_SET_FILTER,
  SHIPMENTS_FILTER_SELECTED_DATA_FETCH_SUCCEEDED,
  SHIPMENTS_FILTER_CLEAR
} from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  status: statuses.idle,
  selectedFilter: [],
  shipments: [],
  filter: [],
  filterBy: ['label', 'uid', 'project'],
  orderBy: 'startDate',
  order: 'asc',
  statusCodes: [100, 200, 300, 400],
  projects: [],
  error: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SHIPMENTS_FILTER_FETCH_STARTED:
      return { ...state, status: statuses.loading, error: null };
    case SHIPMENTS_FILTER_FETCH_SUCCEEDED:
      const { projects, shipments } = action.payload;
      return {
        ...state,
        status: statuses.succeeded,
        shipments,
        statusCodes: [100, 200, 300, 400],
        projects
      };
    case SHIPMENTS_FILTER_FETCH_FAILED:
      return {
        ...state,
        status: statuses.failed,
        shipments: [],
        statusCodes: [],
        error: action.error
      };
    case SHIPMENTS_FILTER_SET_FILTER:
      return { ...state, filter: action.payload };
    case SHIPMENTS_FILTER_SELECTED_DATA_FETCH_SUCCEEDED:
      return {
        ...state,
        selectedFilter: action.payload
      };
    case SHIPMENTS_FILTER_CLEAR:
      return defaultState;
    default:
      return state;
  }
};
